import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, Platform } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { SubscriptionsPage } from './subscriptions.page';
import { SharedModule } from '../shared-module/shared.module';
import { SubscriptionsPageRoutingModule } from './subscriptions-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    CommonModule,
    SharedModule,
    SubscriptionsPageRoutingModule
  ],
  declarations: [SubscriptionsPage]
})
export class SubscriptionsPageModule { }
